// Local Host Setup

// import axios from "axios";
// export const http = axios.create({ baseURL: "http://localhost:5009/" });
// export const barcode = "http://localhost:5009/images/barcodes/";
// export const server = "http://localhost:5009/";
// export const serverSocket = "http://localhost:5009/";
// export const apiUrlPatients = "http://localhost:5009/prijem/pacijenti/";
// export const apiUrlUputnice = "http://localhost:5009/prijem/uputnice/";
// export const apiUrlObradaPregled = "http://localhost:5009/obrada/pregled/";
// export const apiUrlNalaziPregled = "http://localhost:5009/nalazi/pregled";
// export const apiUrlNalaziOutbox = "http://localhost:5009/nalazi/outbox";
// export const apiUrlLabAssays = "http://localhost:5009/assays/lab";
// export const apiUrlAnaAssays = "http://localhost:5009/assays/ana";
// export const apiUrlControlClone = "http://localhost:5009/control/clone";
// export const apiUrlControlEdit = "http://localhost:5009/control/edit";
// export const apiUrlControlResults = "http://localhost:5009/control/results";
// export const apiUrlIntegration = "http://localhost:5009/api/pregled";
// export const apiUrlProdukt = "http://localhost:5009/inventar/produkti";
// export const apiUrlUgovor = "http://localhost:5009/inventar/ugovori";
// export const apiUrlStanje = "http://localhost:5009/inventar/stanje";
// export const apiUrlNarudzbenica = "http://localhost:5009/inventar/narudzbenice";
// export const apiUrlKlijentNarudzbenica= "http://localhost:5009/inventar/knarudzbenice";
// export const apiUrlUlaz = "http://localhost:5009/inventar/ulazpregled";
// export const apiUrlIzlaz = "http://localhost:5009/inventar/izlazpregled";

// Server Setup

import axios from "axios";
export const http = axios.create({ baseURL: "https://skbm.ilab.ba/" });
export const barcode = "https://skbm.ilab.ba/images/barcodes/";
export const server = "https://skbm.ilab.ba/";
export const serverSocket = "https://skbm.ilab.ba/";
export const apiUrlPatients = "https://skbm.ilab.ba/prijem/pacijenti/";
export const apiUrlUputnice = "https://skbm.ilab.ba/prijem/uputnice/";
export const apiUrlObradaPregled = "https://skbm.ilab.ba/obrada/pregled/";
export const apiUrlNalaziPregled = "https://skbm.ilab.ba/nalazi/pregled";
export const apiUrlNalaziOutbox = "https://skbm.ilab.ba/nalazi/outbox";
export const apiUrlLabAssays = "https://skbm.ilab.ba/assays/lab";
export const apiUrlAnaAssays = "https://skbm.ilab.ba/assays/ana";
export const apiUrlControlClone = "https://skbm.ilab.ba/control/clone";
export const apiUrlControlEdit = "https://skbm.ilab.ba/control/edit";
export const apiUrlControlResults = "https://skbm.ilab.ba/control/results";
export const apiUrlIntegration = "https://skbm.ilab.ba/api/pregled";
export const apiUrlProdukt = "https://skbm.ilab.ba/inventar/produkti";
export const apiUrlUgovor = "https://skbm.ilab.ba/inventar/ugovori";
export const apiUrlStanje = "https://skbm.ilab.ba/inventar/stanje";
export const apiUrlNarudzbenica = "https://skbm.ilab.ba/inventar/narudzbenice";
export const apiUrlKlijentNarudzbenica= "https://skbm.ilab.ba/inventar/knarudzbenice";
export const apiUrlUlaz = "https://skbm.ilab.ba/inventar/ulazpregled";
export const apiUrlIzlaz = "https://skbm.ilab.ba/inventar/izlazpregled";


//////////////////
// WEBPACK FOOTER
// ./config/config.js
// module id = 1wn0
// module chunks = 144